import React, { PureComponent } from "react";

import classnames from "classnames";
import styles from "./CardsContainer.local.scss";

class CardsContainerFetching extends PureComponent {
  render() {
    let status = [];
    for (let i = 0; i < 4; i++) {
      status.push(
        <div key={i} className={classnames("cell medium-3")}>
          <div
            className={classnames(
              "grid-x align-center card-body",
              styles.gradiant
            )}
          />
        </div>
      );
    }

    return (
      <div className={styles.large_section_fetching}>
        <div className={styles.frames_fetching}>{status}</div>
      </div>
    );
  }
}

export default CardsContainerFetching;



// WEBPACK FOOTER //
// ./src/components/OrganizationList/CardsContainerFetching.js